export const CLIENT_PERSONAL_INFORMATION_EDIT_MODAL_NAME = 'clientPersonalInformationEdit';
